import { Clock, Globe } from "lucide-react";
import StatusBadge from "./StatusBadge";

const LatestActivity = ({activity,index}) => {
  const formatDateTime = (dateTimeString) => {
    const [date, time] = dateTimeString.split(" ")
    const [year, month, day] = date.split("-")
    return `${day}/${month}/${year}`
  }
  return (
    <div className="border rounded-lg mb-2">
        {/* Activity Items */}
        {/* <div key={index} className="border-b pb-6">
          <div className="flex gap-3">
            <div className="mt-1">
              <div className="w-5 h-5 bg-blue-100 rounded flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-box text-blue-600"
                >
                  <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                  <path d="m3.3 7 8.7 5 8.7-5"></path>
                  <path d="M12 22V12"></path>
                </svg>
              </div>
            </div>
            <div className="flex-1">
              <div className="flex items-center  justify-between gap-2 mb-1">
                <div className="flex items-center gap-2">
                <h5 className="font-medium capitalize">
                  {activity?.project_name}
                </h5>
                {index === 0 && (
                <span className="bg-red-600 text-white text-xs px-2 py-0.5 mb-2 rounded">
                  Latest
                </span>
                )}
                </div>

                {activity?.status_badge &&
                <div>
                  <StatusBadge status={activity?.status_badge} />
                </div>
                }
                
              </div>
              <p className="text-gray-500 text-sm mb-2">
                Last access: {activity?.updatedAt} 
              </p>
              {activity?.application_type &&
              <p className="text-sm mb-3">
                Application Type: {activity?.application_type}
              </p>
                }
            </div>
          </div>
        </div> */}

          <div key={activity.id} className="flex items-center gap-3 p-3 hover:bg-muted/50 transition-colors text-xs">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
              <div className="w-5 h-5 bg-blue-100 rounded flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-box text-blue-600"
                >
                  <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                  <path d="m3.3 7 8.7 5 8.7-5"></path>
                  <path d="M12 22V12"></path>
                </svg>
              </div>
            </div>

            <div className="flex-1">
              <div className="flex items-center gap-2">
                <p className="font-bold text-sm mb-2">{activity?.project_name}</p>
                {index === 0 && (
                  <span className="rounded bg-red-500 px-1.5 py-0.5 text-white -mt-2">Latest</span>
                )}
              </div>

              <div className="flex flex-wrap gap-x-4 gap-y-1 text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Clock className="h-3.5 w-3.5" />
                  <span>Last access: {formatDateTime(activity.updatedAt)}</span>
                </div>
                {activity?.application_type &&
                <div className="flex items-center gap-1">
                  <Globe className="h-3.5 w-3.5" />
                  <span>Application Type: {activity.application_type}</span>
                </div>
                }
              </div>
            </div>
          </div>
    </div>
  );
};
export default LatestActivity;
